import { useState } from "react";
import { Toggle } from "../../../../components/Toggle";
import Search from "../../../../assets/Search.svg";
import {
  Container,
  Header,
  Name,
  Row,
  Searchbar,
  SearchContainer,
  SearchIcon,
  Text,
  Title,
} from "./PermissionForm.styles";
import { PermissonFormProps } from "./PermissionForm.types";

export const PermissionForm: React.FC<PermissonFormProps> = ({
  type,
  rolePermissions,
  setRolePermissions,
}) => {
  const [searchTerm, setSearchTerm] = useState<string>("");

  const editSearchTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleToggle = (id: string) => {
    const newPermissions = [...rolePermissions];
    const toggled = newPermissions.find(
      (permission: any) => permission.id === id
    );
    toggled.hasPermission = !toggled.hasPermission;
    setRolePermissions(newPermissions);
  };

  return (
    <Container>
      <Title>Permission</Title>

      <Header>
        <SearchContainer>
          <SearchIcon src={Search} />
          <Searchbar
            type="text"
            placeholder={"Filter"}
            value={searchTerm}
            onChange={editSearchTerm}
          />
        </SearchContainer>
        <Text>Enabled</Text>
      </Header>

      {rolePermissions
        .filter(
          (item: any) =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
            item.groupName === type
        )
        .map((item: any) => (
          <Row key={item.id}>
            <Name>{item.name}</Name>
            <div onClick={() => handleToggle(item.id)}>
              <Toggle selected={item.hasPermission} />
            </div>
          </Row>
        ))}
    </Container>
  );
};
